import { Button, Group, Iframe, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useModal, usePage, useResource, useTheme } from "@/comn/hooks";
import { APIS, SF_DW_SRCH } from "@/tra/tancis/ptli/temp/dw/services/TdwiDwService";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useSearchParams } from "react-router-dom";

/*
 * DW Iframe Page
 * !== DW Ifame Page ==!
 */
export const TDWI1001001Q = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const scrnId = searchParams.get("scrnId") || "";
    const pgeUid = scrnId.toLowerCase();
    const { pgeUid: pageId, menuId } = usePage({ pgeUid: pgeUid });
    const bsopClsfCd = searchParams.get("bsopClsfCd");
    const modal = useModal();
    const [iframeSrc, setIframeSrc] = useState("");
    const [menuNm, setMenuNm] = useState(""); 

    const fetch = {
        getVeiwList: useFetch({
            api: () =>
                APIS.getVeiwList({
                    bsopClsfCd: bsopClsfCd,
                    scrnId: scrnId,
                }),
            enabled: scrnId !== undefined && bsopClsfCd !== undefined,
            onSuccess: (data: any) => {
                //console.log(data.viewList?.content)
                if (data.viewList?.content[0] !== undefined) {
                    setIframeSrc(data.viewList?.content[0].scrnUrlAddr);
                    
                } else {
                    setIframeSrc("");
                }
            },
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    useEffect(() => {
        fetch.getVeiwList.fetch();
    }, [scrnId]);
    return (

        <Page title={menuNm} id={searchParams.get("scrnId") || ""}>

            {iframeSrc && (
                <Group>
                    <Group.Body>
                        {/* <Iframe height={800}
                        src={iframeSrc}></Iframe> */}
                        
                        <iframe height="800" 
                        style={{clipPath: 'polygon(0% 0%, 100% 0%, 100% calc(100% - 36px), 0% calc(100% - 36px)'}}
                          src={iframeSrc}></iframe>
                    </Group.Body>
                </Group>
            )}
        </Page>
    );
};
